export const NEARMECHECK_ROUTES = {
    START: '/',
    SELECT_LOCATION: '/gmb/select-location',
    CONFIRM_SELECTION: '/gmb/confirm-selection',
    RESULTS: '/results',
    MULTI_LOCATION_RESULTS: '/multi-location-results',
    FAILURE: '/gmb/failure',
};
